import * as React from 'react';

const TiktokIcon = () => {
	return (
		<svg width='27' height='28' viewBox='0 0 27 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect y='0.708008' width='27' height='27' rx='13.5' fill='#BBB5AA' />
			<path
				d='M17.8072 4.75806H14.4777V17.6319C14.4777 19.1659 13.1971 20.4259 11.6035 20.4259C10.0099 20.4259 8.72937 19.1659 8.72937 17.6319C8.72937 16.1255 9.98148 14.8928 11.5182 14.8381V11.6059C8.13177 11.6607 5.3999 14.3176 5.3999 17.6319C5.3999 20.9737 8.18869 23.6581 11.632 23.6581C15.0753 23.6581 17.864 20.9463 17.864 17.6319V11.0307C19.1162 11.9072 20.6528 12.4276 22.2749 12.455V9.22284C19.7707 9.14067 17.8072 7.16849 17.8072 4.75806Z'
				fill='#171716'
			/>
		</svg>
	);
};
export default TiktokIcon;
